import { Box, Card, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { colorScheme } from 'default';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};
function ShowProfile({ ...props }) {
  return (
    <Modal
      open={props.open}
      onClose={props.closeModalClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        {/* Close Icon */}
        <IconButton
          aria-label="close"
          onClick={props.closeModalClick}
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            color: "grey",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box>
          <img src={props.fileName} alt={props.fileName} width="100%" />
        </Box>
      </Card>
    </Modal>
  );
}

export default ShowProfile;
